import * as React from 'react'
import {
  LabelValueList as ValueList,
  LabelValueListItem,
  LabelValueItem
} from '@espoon-voltti/react-components/components'

interface Props {
  values: LabelValueItem[]
  dataQa: string
}

export const LabelValueList = ({ values, dataQa }: Props) => (
  <ValueList dataQa={dataQa}>
    {values.map((v, i) => (
      <LabelValueListItem key={i} {...v} />
    ))}
  </ValueList>
)
